import { render, staticRenderFns } from "./PrivilegeListNewLayout.vue?vue&type=template&id=7e898a88&scoped=true"
import script from "./PrivilegeListNewLayout.vue?vue&type=script&lang=js"
export * from "./PrivilegeListNewLayout.vue?vue&type=script&lang=js"
import style0 from "./PrivilegeListNewLayout.vue?vue&type=style&index=0&id=7e898a88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e898a88",
  null
  
)

export default component.exports